import { createContext } from 'react';
import { FleetManagerDashboardContextProps } from './dashboard.props';

export const FleetManagerDashboardContext = createContext<FleetManagerDashboardContextProps>({
  activeCompany: { id: '', name: '' },
  openPage: () => () => {}
});
